import L from 'leaflet';
import 'mapbox-gl';
import 'mapbox-gl-leaflet';
import 'leaflet.markercluster';
import URL from 'js-handy-url';
import Widgets from 'js-widget-hooks';
import React from 'react';
import ReactDOM from 'react-dom';
import trans from '../util/translator';
import app from '../components/app';
import Map from '../view/Map.jsx';
import {sso_collection_as_array, shown_location_as_exact, sanitize_phone} from '../util/helpers';

class MapsWidget extends React.Component {

    constructor(props) {
        super(props);

        this.map = null;

        // hardcoded fallback
        this.defaultLatitude = 51.151786;
        this.defaultLongitude = 10.415039;

        this.state = {};
    }

    getDefaultLatLng (){

        let default_latitude = this.props.defaultLatitude !== undefined ? this.props.defaultLatitude : this.defaultLatitude,
            default_longitude = this.props.defaultLongitude !== undefined ? this.props.defaultLongitude : this.defaultLongitude
            ;

        return [default_latitude, default_longitude];
    }

    getDefaultZoom (){
        return this.props.defaultZoom !== undefined ? this.props.defaultZoom : 6;
    }

    get_city_geo (center) {

        var state_key = 'city_geo_' + center.slug, geo
            ;

        if (! center.location || ! center.location.geo) {

            if (app.getState(state_key)) {
                geo = app.getState(state_key);
            } else {

                console.log('Unknown location for ' + center.name);
                return null;

                /*
                if (! this.service) {
                    this.service = new gmaps.places.AutocompleteService();
                }
                // takes care of the autocomplete
                if (! this.placeService) {
                    this.placeService = new gmaps.places.PlacesService(new gmaps.Map(document.createElement('div'))); // takes care of the actual places
                }

                this.service.getPlacePredictions( { input : center.name + ', ' + center.countryCode, types : ['geocode']}, function(results) {
                    // console.log('Google Predictions Results: %o', results);

                    if (typeof results == 'object' && results) { // only arrays are processed
                        // we kind of assume here, that we have the first hit as the best one
                        that.placeService.getDetails({ placeId: results[0].place_id }, function(place, status) {
                            if (status === gmaps.places.PlacesServiceStatus.OK) {
                                var state = {};

                                center.location = {
                                    geo: {
                                        latitude:  place.geometry.location.lat(),
                                        longitude:  place.geometry.location.lng()
                                    }
                                };

                                state[state_key] = center.location.geo;
                                app.setState(state);
                            }
                        });
                    }
                });
                */
            }
        } else {
            geo = center.location.geo;
        }

        // geo could not be found jet
        return geo ? L.latLng(geo.latitude, geo.longitude) : null;
    }

    componentDidMount () {
        app.subscribe('current_center', this.centerUpdate.bind(this));

        // realising the scroll top, in case something is set from the ouside

        app.subscribe('external_center_change', function(){
            if(app.getState('external_center_change')) this.scrollToMap();
        }.bind(this));

        // we test, weather there is already a center initalized in the state
        if (app.getState('current_center')) {
            this.centerUpdate(app.getState('current_center'));
        }
    }

    // initalize the google map on an dom element
    initMap (elem) {

        let allowZoom = ! this.props.mainCenter || shown_location_as_exact(this.props.mainCenter);
        let options = {
            scrollWheelZoom: allowZoom,
            maxZoom: 20, // the markercluster seems to need this definetly
            minZoom: 3 // this can not be to low, otherwise the markercluster goes crazy
        };

        let markers = L.markerClusterGroup({
            chunkedLoading: true,
            showCoverageOnHover: false,
            spiderfyOnMaxZoom: false,
            maxClusterRadius: 40
        });

        let addCenterCollectionToLayer = function(centers, exactIcon, privateIcon) {
            if (centers) {
                for ( let i in centers) {

                    let center = centers[i];
                    let latLng = this.get_city_geo(center);

                    if (latLng) {
                        let marker = L.marker(latLng, {
                            title: center.displayName,
                            icon: shown_location_as_exact(center) ? exactIcon : privateIcon
                        });

                        marker.bindPopup(this.getMarkerPopupContent.bind(this, center));
                        marker.dw_center = center;

                        markers.addLayer(marker);
                    }
                }
            }
        }.bind(this);

        if (!allowZoom) {
            options.maxZoom = 10;
            options.minZoom = 10;
        }

        this.map = L.map(elem, options).setView(this.getDefaultLatLng(), this.getDefaultZoom());
        
        L.mapboxGL({
            accessToken: GLOBAL_CONFIG.mapbox_access_token,
            style: 'mapbox://styles/andreas108/cji73o6v60t7z2rpa6xpdxmji',
            attribution: '© <a href="http://www.openstreetmap.org/about/" target="_blank">OpenStreetMap</a> & <a href="https://www.mapbox.com/about/maps/" target="_blank">Mapbox</a>'
        }).addTo(this.map);

        // adding the standard centers
        if (this.props.centers) {
            let exactIcon = L.icon({
                iconUrl: '/img/icon/marker.svg',

                iconSize:     [23, 40], // size of the icon
                iconAnchor:   [11.5, 40], // point of the icon which will correspond to marker's location
                popupAnchor:  [150, -17] // point from which the popup should open relative to the iconAnchor
            });

            let privateIcon = L.icon({
                iconUrl: '/img/icon/marker_private.svg',

                iconSize:     [23, 40], // size of the icon
                iconAnchor:   [11.5, 40], // point of the icon which will correspond to marker's location
                popupAnchor:  [150, -17] // point from which the popup should open relative to the iconAnchor
            });


            addCenterCollectionToLayer(this.props.centers, exactIcon, privateIcon);
        }

        // adding additional centers, if defined
        if (this.props.additional_centers) {
            let exactIcon = L.icon({
                iconUrl: '/img/icon/marker_additional.svg',

                iconSize:     [23, 40], // size of the icon
                iconAnchor:   [11.5, 40], // point of the icon which will correspond to marker's location
                popupAnchor:  [150, -17] // point from which the popup should open relative to the iconAnchor
            });

            let privateIcon = L.icon({
                iconUrl: '/img/icon/marker_additional_private.svg',

                iconSize:     [23, 40], // size of the icon
                iconAnchor:   [11.5, 40], // point of the icon which will correspond to marker's location
                popupAnchor:  [150, -17] // point from which the popup should open relative to the iconAnchor
            });


            addCenterCollectionToLayer(this.props.additional_centers, exactIcon, privateIcon);
        }

        this.map.addLayer(markers);
        this.map.on('popupopen', function (e) {
            let center = e.popup._source.dw_center;
            this.markerClickFunction(center);
        }.bind(this));

        if (this.props.focus_centers) {
            this.map.fitBounds(markers.getBounds());
        }
    }

    reset () {
        this.map.closePopup();
        this.focus(this.getDefaultLatLng(), this.getDefaultZoom());
    }

    scrollToMap () {
        // gmaps is mutating the dom, so we use jquery directly
        $('html,body').animate({scrollTop: $('#dwbn-centers-map').offset().top - $('.navbar').outerHeight(true)}, 600);
    }

    focus (latLon, zoom) {
        this.map.setView(latLon, zoom ? zoom : 12);
    }

    centerUpdate (slug) {
        var center, i;

        if (this.props.centers && this.props.centers.length) {
            for (i = 0; i < this.props.centers.length; i++){
                center = this.props.centers[i];

                if(center.slug === slug) {
                    let latLng = this.get_city_geo(center);
                    this.focus(latLng, shown_location_as_exact(center) ? 12 : 10);
                    this.markerClickFunction(center);
                    break;
                }
            }
        }
    }

    getMarkerPopupContent (center) {
        let latlng = this.get_city_geo(center);
        if (latlng) {

            let typeStr = center.type !== undefined ? trans.t('center.type.' + center.type) : '';
            let phone_numbers = sso_collection_as_array(center.phoneNumbers).filter(function(phone){
                return phone.phone_type !== 'fax';
            });
            let center_phone_html = phone_numbers.map(function(phone){
                return '<div><a href="tel:' + sanitize_phone(phone.phone) + '">' + phone.phone + '</a></div>';
            }).join("\n");
            let external_url = center.homepage ? new URL(center.homepage) : false;
            let center_link_ext = '';

            if (external_url) {
                center_link_ext = '<div><a target="' + (external_url.isInternalURL() ? "_self" : "_blank") + '" href="' + external_url.toString() + '">' + external_url.host.replace('www.', '')  + '</a></div>';
            }

            return '<div>' +
                '<h2 class="popup__headline">' + typeStr + ' ' + center.displayName +'</h2>' +
                center_phone_html +
                (center.email ? '<div><a href="mailto:' + center.email.toLocaleLowerCase() + '">' + center.email.toLocaleLowerCase() + '</a></div>' : '') +
                center_link_ext +
            '</div>';
        }

        return null;
    }

    // this is called, once the marker is clicked
    markerClickFunction (center, latlng, execute) {
        if (document.querySelector('#center-details')) {

            let phone_numbers = sso_collection_as_array(center.phoneNumbers).filter(function(phone){
                    return phone.phone_type !== 'fax';
                }),
                center_phone_html,
                typeStr = center.type !== undefined ? trans.t('center.type.' + center.type) : '',
                country = center.countryCode !== GLOBAL_CONFIG.site_country ? ', ' + trans.t('country.long.' + center.countryCode) : '',
                addresses = sso_collection_as_array(center.addresses).map(function(address){
                        let co = address.careof ? <div>{'c/o ' + address.careof }</div> : null;
                        return  address.address_type === "meditation" ? <div key={address.id} className="p">{co}
                                <div>{address.street_address}</div>
                                <div>{address.postal_code} {address.city}{country}</div>
                            </div> : null;
                    })
            ;
            let external_url = center.homepage ? new URL(center.homepage) : false;
            let center_link_ext = null;
            let center_email_html = null;

            if (! addresses || ! addresses.length) {
                addresses = <p>{trans.t('center.contact.private')}</p>;
            }

            if (external_url) {
                center_link_ext = <a target={ external_url.isInternalURL() ? "_self" : "_blank" } href={ external_url.toString() }>{ external_url.host.replace('www.', '') }</a>;
            }

            if (center_link_ext) {
                center_link_ext = <div>Web: {center_link_ext}</div>;
            }

            if (center.email) {
                center_email_html = <div>E-Mail: <a href={ 'mailto:' + center.email.toLocaleLowerCase() }>{ center.email.toLocaleLowerCase() }</a></div>;
            }

            center_phone_html = phone_numbers.map(function(phone){
                return <div key={phone.phone}>{trans.t('phone.short.' + phone.phone_type)}: <a href={"tel:" + sanitize_phone(phone.phone)}>{phone.phone}</a></div>;
            });

            ReactDOM.render(
                <div className="page-element">
                    <h2 className="h3"><a target="_blank" href={ center.homepage }>{typeStr} { center.displayName }</a></h2>
                    {addresses}

                    {center_phone_html}
                    {center_email_html}
                    {center_link_ext}

                </div>
                , document.querySelector('#center-details')
            );
        }

        // we communicate the event of the dissplayed center to the app and reset outside influenz
        app.setState({current_center: center.slug, external_center_change: null});
    }

    render () {
        return <Map ref="map" init_map={this.initMap.bind(this)} />
    }
}

Widgets.register('googleMaps', function (elem) {
    ReactDOM.render(<MapsWidget />, elem);
});

export default MapsWidget;
